<div class="flex">
  <sbnb-subnav [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-edit-transaction'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full relative">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs>
          <div class="flex">
            <h2 class="flex-1 text-center sbnbDesktop:text-left">
              Edit {{ recurring ? 'Recurring Transaction' : 'Transaction' }}
            </h2>
          </div>
        </sbnb-page-header>
        <div class="flex">
          <h2 class="flex-1">Edit {{ recurring ? 'Recurring Transaction' : 'Transaction' }}</h2>
        </div>
      </app-feature-flag-tabs>
    </div>

    <sbnb-transaction-form
      [editing]="true"
      [recurring]="recurring"
      (saveSuccess)="onSave()"></sbnb-transaction-form>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
